<template>
  <div class="custom-number" @wheel="handleValueChangeByWheel">
    <div
      class="custom-number-wrapper"
      v-touch-options="touchConfig"
      v-touch:start.disablePassive="handleTouchStart"
      v-touch:moving="handleTouchMove"
      v-touch:end="handleTouchEnd"
    >
      <div class="number-input value-next">
        {{ value + 1 }}
      </div>
      <input
        v-if="editMode"
        class="number-input"
        :min="config.min"
        :step="config.step"
        :id="config.id"
        :max="config.max"
        :placeholder="config.placeholder"
        :value="value"
        @input="updateValue($event)"
        type="number"
        ref="config.ref"
        @blur="editMode = false"
        @keyup.enter="editMode = false"
        @keydown="handleKeyDown"
        v-focus
      />
      <div
        v-else
        class="number-input value-current"
        v-touch:touchhold="handleTouchHold"
        v-touch:tap="handleDoubleTap"
        @click="handleClick"
      >
        {{ value }}
      </div>
      <div class="number-input value-previous">
        {{ value - 1 == -1 ? "-" : value - 1 }}
      </div>
    </div>
    <div class="buttons-wrapper">
      <button
        class="btn-number"
        @mousedown="handleValueChangeByHold($event, 'up', config.ref)"
        @mouseleave="handleStopValueChangeByHold"
        @mouseup="handleStopValueChangeByHold"
        @click="handleValueChangeByArrowBtn($event, 'up', config.ref)"
      >
        <i class="far fa-triangle"></i>
      </button>
      <button
        class="btn-number"
        @mousedown="handleValueChangeByHold($event, 'down', config.ref)"
        @mouseleave="handleStopValueChangeByHold"
        @mouseup="handleStopValueChangeByHold"
        @click="handleValueChangeByArrowBtn($event, 'down', config.ref)"
      >
        <i class="far fa-triangle fa-flip-vertical"></i>
      </button>
    </div>
  </div>
</template>
<script>
export default {
  name: "NumericInput",
  props: {
    value: {
      type: Number,
      required: true,
    },
    config: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      touchConfig: {
        disableClick: false,
        touchClass: "",
        tapTolerance: 10,
        touchHoldTolerance: 400,
        swipeTolerance: 30,
        longTapTimeInterval: 400,
        namespace: "touch",
      },
      editMode: false,
      posYStart: 0,
      initStep: 10,
      holdTimout: false,
      holdInterval: false,
      holdTimoutValue: 500,
      doubleTapCounter: 0,
    };
  },
  methods: {
    handleTouchHold: function (e) {
      this.editMode = true;
    },
    handleValueChangeByWheel: function (e) {
      e.preventDefault();
      const deltaY = e.deltaY;
      if (deltaY >= 0) {
        if (this.value > this.config.min) this.$emit("decreaseValue");
      } else {
        if (this.value < this.config.max) this.$emit("increaseValue");
      }
    },
    handleTouchStart: function (e) {
      if (this.editMode) {
        return;
      }
      e.preventDefault();
      if (e.changedTouches === undefined || e.changedTouches.length !== 1) {
        return;
      }
      const touches = e.touches || e.originalEvent.touches;
      this.posYStart = touches[0].clientY;
    },
    handleTouchMove: function (e) {
      if (
        this.editMode ||
        e.changedTouches === undefined ||
        e.changedTouches.length !== 1 ||
        !this.posYStart
      ) {
        return;
      }
      let step = this.initStep;
      let posY = e.changedTouches[0].clientY;
      let posYdiff = this.posYStart - posY;
      if (Math.abs(posYdiff) > step) {
        if (posY < this.posYStart) {
          if (this.value < this.config.max) {
            this.$emit("increaseValue");
            this.posYStart = posY;
          }
        } else {
          if (this.value > this.config.min) {
            this.$emit("decreaseValue");
            this.posYStart = posY;
          }
        }
      } else {
        return;
      }
    },
    handleTouchEnd: function () {
      this.posYStart = 0;
    },
    handleValueChangeByArrowBtn: function (e, direction, inputRefString) {
      let editMode = this.editMode;
      if (editMode) {
        let inputEl = this.$refs[inputRefString];
        switch (direction) {
          case "up":
            console.log("up");
            inputEl.stepUp();
            break;
          case "down":
            inputEl.stepDown();
            break;
          default:
            console.log(`Error`);
        }
      } else {
        switch (direction) {
          case "up":
            if (this.value >= this.config.min && this.value < this.config.max)
              this.$emit("increaseValue");
            break;
          case "down":
            if (this.value > this.config.min && this.value <= this.config.max)
              this.$emit("decreaseValue");
            break;
          default:
            console.log(`Error`);
        }
      }
    },
    handleValueChangeByHold: function (e, direction, inputRefString) {
      switch (direction) {
        case "up":
          if (!this.holdTimout) {
            let globalThis = this;
            this.holdTimout = setTimeout(function (e) {
              console.log("timeout");

              if (!globalThis.holdInterval) {
                globalThis.holdInterval = setInterval(function (e) {
                  if (
                    globalThis.value >= globalThis.config.min &&
                    globalThis.value < globalThis.config.max
                  )
                    globalThis.$emit("increaseValue");
                }, 50);
              }
            }, this.holdTimoutValue);
          }
          break;
        case "down":
          if (!this.holdTimout) {
            let globalThis = this;
            this.holdTimout = setTimeout(function (e) {
              if (!globalThis.holdInterval) {
                globalThis.holdInterval = setInterval(function (e) {
                  if (
                    globalThis.value > globalThis.config.min &&
                    globalThis.value <= globalThis.config.max
                  )
                    globalThis.$emit("decreaseValue");
                }, 50);
              }
            }, this.holdTimoutValue);
          }
          break;
        default:
          console.log(`Error`);
      }
    },
    handleStopValueChangeByHold: function () {
      clearTimeout(this.holdTimout);
      this.holdTimout = false;
      if (this.holdInterval) {
        clearInterval(this.holdInterval);
        this.holdInterval = false;
      }
    },
    updateValue: function (e) {
      let value = e.target.value.replace(/[^0-9]*/g, "");
      if (value >= this.config.min && value <= this.config.max) {
        this.$emit("input", value);
      }
    },
    handleClick: function (e) {
      this.editMode = true;
    },
    handleDoubleTap: function (e) {
      this.doubleTapCounter++;
      if (this.doubleTapCounter == 1) {
        this.timer = setTimeout(() => {
          this.doubleTapCounter = 0;
        }, 300);
        return;
      }

      clearTimeout(this.timer);
      this.doubleTapCounter = 0;
      this.editMode = true;
    },
    handleKeyDown: function (e) {
      if (e.key === ".") e.preventDefault();
    },
  },
  directives: {
    focus: {
      inserted(el) {
        el.focus();
      },
    },
  },
};
</script>
